import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { Breadcrumb } from './Breadcrumb';
import { Heading } from './Heading';
import { Description } from './Description';
import { ProductGrid } from './ProductGrid';
/**
 * Shop All Products page (/shop/).
 *
 * Self-contained: every section lives in `./` and is owned by this page only.
 */
export function ShopAllProductsPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-800">
      <Header data-id="element-801" />
      <main className="flex-grow pt-32 pb-20" data-id="element-802">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-803">
          <Breadcrumb data-id="element-804" />
          <Heading data-id="element-805" />
          <Description data-id="element-806" />
          <ProductGrid data-id="element-807" />
        </div>
      </main>
      <Footer data-id="element-808" />
    </div>;
}